import React, { useEffect, useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { InputOtp } from "primereact/inputotp";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";

function OtpVerifyPopup({ show, onClose, formData, onVerified }) {
  const [token, setTokens] = useState("");

  const { isLoading, postData: otpVerification } = usePostRequest(
    API_ENDPOINTS.VERIFY_CARDS_OTP
  );

  const modalRef = useRef(null);

  const onSuccess = (response) => {
    toast.success(response?.message);
    setTokens("");
    if (onVerified) onVerified(response);
    onClose();
  };

  const onError = (error) => {
    toast.error(error?.message || "Failed to verify OTP.");
    setTokens("");
  };

  console.log("formData", formData);

  const handleVerify = () => {
    const payload = {
      // username: formData?.username,
      id: formData?.id,
      otp: token,
    };
    otpVerification(payload, onSuccess, onError);
  };

  // Enter key handler for submit
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && show && token.length === 6 && !isLoading) {
        handleVerify();
      }
    };
    if (show) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, token, isLoading]);

  // Focus modal on open
  useEffect(() => {
    if (show && modalRef.current) {
      modalRef.current.focus();
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="otp-modal-container"
    >
      <div ref={modalRef} tabIndex={-1}>
        <Modal.Header closeButton className="justify-content-center">
          <Modal.Title>Verify Your Identity</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 text-center">
          <p>Enter the 6-digit code sent to your email.</p>
          <div className="otp-input-wrapper">
            <InputOtp
              value={token}
              onChange={(e) => setTokens(e.value)}
              length={6}
              integerOnly
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="warning"
            onClick={handleVerify}
            disabled={isLoading || token.length < 6}
          >
            {isLoading ? "Verifying..." : "Verify"}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default OtpVerifyPopup;
